import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';
import Utility from "../utilities/utility";

class UserRestrictionModal extends Component {

    addRestriction = () => {
        const restrictionId = document.getElementById("restrictionId").value;

        if (Utility.isEmpty(restrictionId)) {
            Utility.showAlertWithId(
                'restrictionMessageHolder',
                'Please select a restriction',
                'danger',
                true
            );
            return;
        }

        this.props.onAdd(restrictionId);
    }

    render() {

        const {
            show,
            onClose,
            selectedUser,
            restrictions,
            userRestrictions,
            onRemove
        } = this.props;

        return (
            <Modal show={show} size="lg" onHide={onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        User Restrictions
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>

                    <div id="restrictionMessageHolder"></div>

                    {selectedUser &&
                        <div className="mb-3">
                            <strong>
                                {selectedUser.name} - {selectedUser.username}
                            </strong>
                        </div>
                    }

                    <div className="row">
                        <div className="col-md-9">
                            <label className="label">Restriction</label>

                            <select
                                className="form-control"
                                id="restrictionId"
                            >
                                <option></option>

                                {restrictions.map(item =>
                                    <option
                                        key={item.id}
                                        value={item.id}
                                    >
                                        {item.name} ({item.code})
                                    </option>
                                )}
                            </select>
                        </div>

                        <div className="col-md-3 d-flex align-items-end">
                            <button
                                className="btn btn-primary w-100"
                                onClick={this.addRestriction}
                            >
                                Add
                            </button>
                        </div>
                    </div>

                    <hr/>

                    <h5>Applied Restrictions</h5>

                    <table className="table table-bordered table-sm">
                        <thead>
                        <tr>
                            <th>Name</th>
                            <th>Code</th>
                            <th>Status</th>
                            <th width="100">Action</th>
                        </tr>
                        </thead>

                        <tbody>

                        {userRestrictions.length > 0 &&
                            userRestrictions.map(item =>
                                <tr key={item.id}>
                                    <td>{item.restriction.name}</td>
                                    <td>{item.restriction.code}</td>
                                    <td>
                                        {item.active ?
                                            <span className="badge bg-danger">
                                                Active
                                            </span>
                                            :
                                            <span className="badge bg-secondary">
                                                Inactive
                                            </span>
                                        }
                                    </td>

                                    <td>
                                        <button
                                            className="btn btn-danger btn-sm"
                                            onClick={() => onRemove(item.id)}
                                        >
                                            Remove
                                        </button>
                                    </td>
                                </tr>
                            )
                        }

                        {userRestrictions.length === 0 &&
                            <tr>
                                <td colSpan="4" className="text-center">
                                    No restrictions
                                </td>
                            </tr>
                        }

                        </tbody>
                    </table>

                </Modal.Body>
            </Modal>
        );
    }
}

export default UserRestrictionModal;